"use client";

import { useEffect } from "react";
import Link from "next/link";
import * as Sentry from "@sentry/nextjs";

import { ErrorScreen } from "@/components/error-screen";
import "./globals.css";

export default function GlobalError({
  error,
  retry,
}: {
  error: Error & { digest?: string };
  retry: () => void;
}) {
  useEffect(() => {
    Sentry.captureException(error);
  }, [error]);

  return (
    <html lang="en">
      <body>
        <title>Something went wrong · Collr</title>
        <ErrorScreen
          code="SYSTEM FAULT // ROOT"
          title="The workshop lost power."
          description="Collr could not load its main frame. Try restarting it, or return home."
          icon="fa-plug-circle-xmark"
          note={error.digest ? `INCIDENT TAG: ${error.digest}` : undefined}
        >
          <button type="button" onClick={retry} className="paw-btn">
            TRY AGAIN
          </button>
          <Link href="/" className="paw-btn-ghost text-center">
            RETURN HOME
          </Link>
        </ErrorScreen>
      </body>
    </html>
  );
}
